import helpMap from './helpMap'

function normalizeRoute(route: string): string {
  const withoutQuery = route.split('?')[0]?.split('#')[0] ?? route
  let normalized = withoutQuery.trim() || '/'

  if (!normalized.startsWith('/')) {
    normalized = `/${normalized}`
  }

  if (normalized.length > 1) {
    normalized = normalized.replace(/\/+$/, '')
  }

  return normalized
}

function routePatternToRegex(pattern: string): RegExp {
  const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const withParams = escaped.replace(/:(\w+)/g, '[^/]+')
  return new RegExp(`^${withParams}$`)
}

function toAutoFile(route: string): string {
  if (route === '/') return 'index.md'

  const fileName = route
    .slice(1)
    .split('/')
    .filter(Boolean)
    .map((segment) => {
      if (segment.startsWith(':') || /^\d+$/.test(segment)) {
        return 'id'
      }
      return segment.toLowerCase().replace(/[^a-z0-9-_]/g, '-')
    })
    .join('-')

  return fileName ? `${fileName}.md` : 'index.md'
}

export function resolveHelpFile(route: string): string {
  const normalized = normalizeRoute(route)
  const direct = helpMap[normalized]
  if (direct) {
    return direct
  }

  for (const [pattern, file] of Object.entries(helpMap)) {
    if (!pattern.includes(':')) {
      continue
    }

    if (routePatternToRegex(pattern).test(normalized)) {
      return file
    }
  }

  return toAutoFile(normalized)
}
